import {useAIToolsContext} from "../../../../../../../../../../context/AIToolsProvider";
import ImageUpload from "../FaceSwap/ImageUploader";
import './AvatarConverter.scss'
import AvatarStyleSelector from "./AvatarStyleSelector";
import NumberSlider from "./NumberSlider";
import useFetchAuthImage from "../../../../../../../../../../../../../../Hooks/useFetchAuthImage";
import {useADSContext} from "../../../../../../../../../../context/ADSProvider";
import {styled} from "@mui/material/styles";

const Description = styled('span')({
  fontWeight: '500',
  fontSize: '14px',
  color: '#646666',
  margin: '32px 0',
})

const AvatarConverter = () => {
  const {
    firstSelectedImage,
    setFirstSelectedImage,

    firstSelectedImageServerPath,
    setFirstSelectedImageServerPath,

    selectedAvatarIndex,
    setSelectedAvatarIndex,

    selectedAvatarStrengthIndex,
    setSelectedAvatarStrengthIndex
  } = useAIToolsContext();

  const {handleSelectProduct} = useADSContext();

  const {data: authImageSrc, loading: loadingAuthImageSrc} = useFetchAuthImage({path: firstSelectedImageServerPath})

  const clearImage = () => {
    setFirstSelectedImage(null);
    setFirstSelectedImageServerPath(null);
    handleSelectProduct({})
  }

  return (
    <div className='avatar-converter'>
      <AvatarStyleSelector
        selectedAvatarIndex={selectedAvatarIndex}
        setSelectedAvatarIndex={setSelectedAvatarIndex}
      />

      <div className="slider-holder">
        <p className="slider-text">Original</p>
        <NumberSlider
          sliderNumber={selectedAvatarStrengthIndex}
          setSliderNumber={setSelectedAvatarStrengthIndex}
        />
        <p className="slider-text second">Avatar</p>
      </div>

      <Description>Select or upload an image, choose a style, adjust the strength, and click Generate.</Description>

      <ImageUpload
        inputId='first-image-upload' // id to trigger input tag, must be unique
        label="Upload from device"
        loading={loadingAuthImageSrc}
        uploadedUrl={authImageSrc} // will prioritize over uploadedFile if exists
        uploadedFile={firstSelectedImage}
        onUploadFile={setFirstSelectedImage}
        onDeleteFile={clearImage}
        width={560}
        height={560}
        persistSize
      />
    </div>
  );
};

export default AvatarConverter;
